/**
 * This is AdBugOffersRail component.
 *
 * @module views/components/AdBugOffersRail
 * @memberof -Common
 */
import './AdBugOffersRail.scss';

import React, { useRef } from 'react';

import PropTypes from 'prop-types';

import Rail, { Slide } from '@ulta/core/components/Rail/Rail';
import { hasItems } from '@ulta/core/utils/array/array';

import AdBugOfferCard from '@ulta/components/AdBugOfferCard/AdBugOfferCard';
/**
 * Represents a AdBugOffersRail component
 *
 * @method
 * @param {AdBugOffersRailProps} props - React properties passed from composition
 * @returns AdBugOffersRail
 */
export const AdBugOffersRail = function( props ){
  const {
    title,
    nextClickAction,
    previousClickAction,
    items,
    viewAllAction,
    countLabel,
    nextAccessibility,
    previousAccessibility,
    carouselAccessibility,
    carouselCardAccessibility,
    carouselDetailsAccessibility
  } = props;

  const AdBugOfferRailRef = useRef( null );

  if( !hasItems( items ) ){
    return null;
  }

  const railMeta = {
    countLabel,
    nextAccessibility,
    previousAccessibility
  };
  const railADAmeta = {
    carouselAccessibility,
    carouselCardAccessibility,
    carouselDetailsAccessibility

  };

  return (
    <div className='AdBugOffersRail' ref={ AdBugOfferRailRef }>
      <Rail
        railRef={ AdBugOfferRailRef }
        headline={ title?.text }
        headlineTag={ title?.htmlTag || 'h2' }
        items={ items }
        showCountLabel={ true }
        _railADAmeta={ railADAmeta }
        _railMeta={ railMeta }
        viewAllAction={ viewAllAction }
        nextClickAction={ nextClickAction }
        previousClickAction={ previousClickAction }
        sliderPerViewXL={ 1.1 }
        slidesPerGroupXL={ 1 }
        sliderPerViewLG={ 1.1 }
        slidesPerGroupLG={ 1 }
        sliderPerViewMD={ 2.0 }
        slidesPerGroupMD={ 1 }
        sliderPerViewSM={ 1.15 }
        slidesPerGroupSM={ 1 }
      >
        { items?.length > 0 &&
          items?.map( ( items, moduleIndex ) => (
            <Slide key={ `AdBugOffersRail${moduleIndex + 1} ` }>
              <AdBugOfferCard { ...items } />
            </Slide>
          ) ) }
      </Rail>
    </div>
  );

};

/**
 * Property type definitions
 *
 * @typedef AdBugOffersRailProps
 * @type {object}
 * @property {object} title - Sets the headline title.
 * @property {object} viewAllAction - Sets viewAllAction
 * @property {object} previousClickAction - This is the action object for the Next button.
 * @property {object} nextClickAction - This is the action object for the Previous button.
 * @property {object} railAdaMeta - Sets carouselAccessibility.
 * @property {array} items - Set the Item array.
 * @property {string} countLabel - shows the number of items
 *
 */
export const propTypes = {
  title: PropTypes.object,
  nextClickAction: PropTypes.object,
  previousClickAction: PropTypes.object,
  items: PropTypes.array,
  railAdaMeta: PropTypes.object,
  viewAllAction: PropTypes.object,
  countLabel: PropTypes.string
};

AdBugOffersRail.propTypes = propTypes;

export default AdBugOffersRail;